import { TranslationString } from 'shared/entities/localization';

import { WzOAuthClientError, WzOAuthErrorCode } from './client';
import { mapWzOAuthErrorToMessage } from './server';

export const isWzOAuthClientError = (
  code: WzOAuthErrorCode
): code is WzOAuthClientError =>
  Object.values(WzOAuthClientError).some((item) => item === code);

export const mapWzOAuthErrorCodeToMessage = (
  code: WzOAuthErrorCode
): TranslationString =>
  isWzOAuthClientError(code)
    ? (t) =>
        t(`channels.errors.wzOAuth.${code}`, {
          ns: 'entities'
        })
    : mapWzOAuthErrorToMessage(code);
